import React from 'react';
import { Space, Badge, Typography, Tag, Select } from 'antd';
import { CoffeeOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { formatTimeStatus, getStatusStyles } from '../utils';

const { Text } = Typography;

const AgentStatusBar = ({
    status,
    stateSeconds,
    breakSeconds,
    campaigns,
    breakStatuses,
    handleStatusChange
}) => {
    // Calculate styles
    const statusStyle = getStatusStyles(status, breakStatuses);

    return (
        <div className="agent-status-bar" id="agent-status-bar" style={{
            display: 'flex',
            alignItems: 'center',
            background: statusStyle.bg,
            border: `1px solid ${statusStyle.border}`,
            padding: '8px 25px',
            borderRadius: '12px',
            justifyContent: 'space-between',
            transition: 'all 0.3s ease',
            marginBottom: '20px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
        }}>
            <Space size="large">
                <Space>
                    <Badge
                        status={status === 'offline' ? 'warning' : 'processing'}
                        color={statusStyle.text}
                        style={{ transform: 'scale(1.2)' }}
                    />
                    {/* TIMER PRINCIPAL */}
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                        <Text strong style={{ color: statusStyle.text, fontSize: '24px', lineHeight: '1.2', fontFamily: 'monospace' }}>
                            {status !== 'online' && status !== 'offline'
                                ? formatTimeStatus(stateSeconds)
                                : '--:--:--'}
                        </Text>
                        <Text type="secondary" style={{ fontSize: '11px' }}>
                            TIEMPO ACUMULADO
                        </Text>
                    </div>
                </Space>

                {/* TIMER SECUNDARIO */}
                {(status !== 'online' && status !== 'offline') && (
                    <div style={{ display: 'flex', flexDirection: 'column', borderLeft: '1px solid rgba(0,0,0,0.1)', paddingLeft: 15 }}>
                        <Space size="small">
                            {status.startsWith('break_') ? <CoffeeOutlined /> : <ClockCircleOutlined />}
                            <Text strong style={{ color: statusStyle.text, fontSize: '16px', fontFamily: 'monospace' }}>
                                {formatTimeStatus(breakSeconds)}
                            </Text>
                        </Space>
                        <Text type="secondary" style={{ fontSize: '10px' }}>
                            EN ESTADO ACTUAL
                        </Text>
                    </div>
                )}
            </Space>

            <Space>
                {status.startsWith('break_') && (
                    <Tag color="orange" style={{ fontSize: '14px', padding: '5px 10px' }}>
                        {statusStyle.label}
                    </Tag>
                )}
            </Space>

            <Select
                id="agent-status-selector"
                className="agent-status-selector"
                value={status}
                onChange={handleStatusChange}
                variant="borderless"
                disabled={campaigns.length === 0}
                style={{ width: 220, fontWeight: 'bold', fontSize: '16px', textAlign: 'right' }}
            >
                {status === 'offline' && (
                    <Select.Option value="offline" disabled>
                        <span style={{ color: '#faad14' }}>RECUPERANDO...</span>
                    </Select.Option>
                )}

                {(status === 'available' || status === 'online') && (
                    <Select.Option value="online" disabled={['incall', 'wrapup', 'ringing'].includes(status)}>
                        <span style={{ color: '#8c8c8c' }}>NO DISPONIBLE</span>
                    </Select.Option>
                )}

                <Select.Option value="available" disabled={['incall', 'wrapup', 'ringing'].includes(status)}>
                    <span style={{ color: '#52c41a' }}>DISPONIBLE</span>
                </Select.Option>

                {(status === 'available' || status.startsWith('break_')) && breakStatuses.map(b => (
                    <Select.Option key={b.id} value={`break_${b.id}`} disabled={['incall', 'wrapup', 'ringing'].includes(status)}>
                        <span style={{ color: '#fa8c16' }}>{b.name.toUpperCase()}</span>
                    </Select.Option>
                ))}

                {status === 'incall' && <Select.Option value="incall" disabled><span style={{ color: '#f5222d' }}>EN LLAMADA</span></Select.Option>}
                {status === 'ringing' && <Select.Option value="ringing" disabled><span style={{ color: '#1890ff' }}>TIMBRANDO</span></Select.Option>}
                {status === 'wrapup' && <Select.Option value="wrapup" disabled><span style={{ color: '#d4b106' }}>ESPERANDO FORMULARIO</span></Select.Option>}
            </Select>
        </div >
    );
};

export default AgentStatusBar;
